import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=c9111b36&scoped=true&"
import script from "./settings.component.ts?vue&type=script&lang=ts&"
export * from "./settings.component.ts?vue&type=script&lang=ts&"
import style0 from "./settings.scss?vue&type=style&index=0&id=c9111b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9111b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9111b36')) {
      api.createRecord('c9111b36', component.options)
    } else {
      api.reload('c9111b36', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=c9111b36&scoped=true&", function () {
      api.rerender('c9111b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/settings.vue"
export default component.exports